import { render, staticRenderFns } from "./ctrl.vue?vue&type=template&id=b82f6ad4&"
import script from "./ctrl.vue?vue&type=script&lang=js&"
export * from "./ctrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports